<template>
	<div class="registerClient">
		<div class="center content-inputs items-start">
			<div class="form-input">
				<vs-input :label="$t('personName')" name="name" v-validate="'required|min:3'"
						  v-model="name"/>
				<span v-if="errors.first('name')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="form-input">
				<vs-input label="E-Mail" name="email" v-validate="'required|email|min:3'"
						  v-model="email"/>
				<span v-if="errors.first('email')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="form-input">
				<vs-input :label="$t('surname')" name="surname" v-validate="'required|min:3'"
						  v-model="surname"/>
				<span v-if="errors.first('surname')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="form-input">
				<vx-input-group>
					<vs-password
						:label="$t('password')"
						data-vv-validate-on="blur"
						v-validate="'required|min:6|max:32'"
						type="password"
						ref="password"
						name="password"
						v-model="password"/>
				</vx-input-group>
				<span v-if="errors.first('password')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="form-input">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('sex') }}</label>
					<div class="vs-con-input">
					</div>
					<v-select v-model="sex" :reduce="country => country.id" label="name" v-validate="'required'"
							  name="sex"
							  :options="[{id: 1, name: $t('male')},{id: 2, name: $t('female')}]"
							  :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
				</div>
				<span v-if="errors.first('sex')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="form-input">
				<vx-input-group>
					<vs-password
						:label="$t('repeatPassword')"
						data-vv-validate-on="blur"
						v-validate="'required|confirmed:password'"
						type="password"
						ref="repassword"
						name="repassword"
						v-model="repassword"/>
				</vx-input-group>
				<span v-if="errors.first('repassword')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="form-input">
				<div class="vs-component vs-con-input-label vs-input vs-input-primary">
					<label class="vs-input--label">{{ $t('country') }}</label>
					<div class="vs-con-input">
					</div>
					<v-select
						v-model="country"
						:reduce="country => country.id"
						label="name"
						v-validate="'required'"
						name="country"
						:options="countries"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						class="single-row-select"
					/>
				</div>
				<span v-if="errors.first('country')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

		</div>
		<div class="flex flex-wrap justify-between mb-3 my-5">
			<vs-button :disabled="!validateForm"
					   @click="register">{{ $t('registration') }}
			</vs-button>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "registerClient",
	data() {
		return {
			email: '',
			name: '',
			surname: '',
			password: '',
			repassword: '',
			sex: '',
			country: '',

			countries: []
		}
	},
	components: {
		'v-select': vSelect,
	},
	async created() {
		try {
			let res = await this.$http.get('/settings/get-countries');
			this.countries = res.data.data;
		} catch (e) {
			this.$vs.notify({
				title: 'Error',
				text: e.message,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger'
			})
		}

	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.email !== '' && this.password !== ''
		}
	},
	methods: {
		toggleShow(ref) {
			let input = this.$refs[ref].$el.querySelector('input');
			input.type = input.type === 'password' ? 'text' : 'password';
		},
		register() {
			this.$validator.validateAll().then(result => {
				if (result) {
					const formData = {
						email: this.email,
						first_name: this.name,
						last_name: this.surname,
						password: this.password,
						password2: this.repassword,
						gender: this.sex,
						country: this.country,
						website_uid: this.$store.state.website.uid
					};

					function getFormData(object) {
						const formData = new FormData();
						Object.keys(object).forEach(key => formData.append(key, object[key]));
						return formData;
					}

					this.$emit('register', getFormData(formData));
				} else {
					// form have errors
				}
			})

		}
	}
}
</script>

<style lang="scss">
.registerClient {
	.vx-input-group .append-text.btn-addon .vs-button {
		height: 2.7rem;
		width: 2.7rem;
		justify-content: center;
		padding: 0 !important;
		margin-top: 21px;
		align-items: center;

		&-text {
			margin-top: 4px;
		}
	}
}

</style>
